import { Observable, Subject } from 'rxjs';
import { BaseDialog } from '@core/dialog/shared/models/base-dialog.interface';

export class DialogRef<C extends BaseDialog = BaseDialog, R = unknown> {
  readonly #afterClosed = new Subject<R | null>();
  #componentInstance: C | null = null;

  close(result: R | null = null): void {
    this.#afterClosed.next(result);
    this.#afterClosed.complete();
  }

  afterClosed$(): Observable<R | null> {
    return this.#afterClosed.asObservable();
  }

  get componentInstance(): C {
    if (!this.#componentInstance) {
      throw new Error('Dialog component instance is not available.');
    }

    return this.#componentInstance;
  }

  setComponentInstance(componentInstance: C | null): void {
    this.#componentInstance = componentInstance;
  }
}
